
























import { Component, Prop, Emit, Vue } from 'vue-property-decorator'
import DeckCover from '@/components/deck-cover.vue'
import { cardWHFromSize, cardSizeFromWH, iconPath } from '../lib'

@Component({
  components: { DeckCover }
})
export default class DeckForm extends Vue {
  @Prop() public readonly deck!: Deck

  private icons = ['mouth-watering', 'robe', 'thorny-triskelion']
  private sizes = [
    { title: '88x62 (Poker)', value: '88x62' },
    { title: '88x56 (Bridge)', value: '88x56' }
  ]

  private icon: string
  private name: string
  private description: string
  private color: string
  private cardSize: string

  constructor () {
    super()
    this.icon = this.deck.icon
    this.name = this.deck.name
    this.description = this.deck.description
    this.color = this.deck.color
    this.cardSize = cardSizeFromWH(this.deck.cardWidth, this.deck.cardHeight)
  }

  private get iconPath () {
    return iconPath(this.icon)
  }

  private get newDeck () {
    const [cardWidth, cardHeight] = cardWHFromSize(this.cardSize)

    return {
      ...this.deck,
      name: this.name,
      description: this.description,
      color: this.color,
      icon: this.icon,
      cardWidth,
      cardHeight
    }
  }

  @Emit('save')
  private saveDeck (): Deck {
    return this.newDeck
  }
}
